<template>
	<section class="main">
		<header class="panel-heading">
			<h3 class="panel-title">扣(銷)點查詢</h3>
		</header>
		<section class="panel panel-default" style="margin-bottom: 0px;">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">查詢條件</h4>
			</header>
			<div id="searchArea" class="panel-collapse collapse">
				<div class="panel-body">
					<div class="row form-group">
						<div class="col-md-12 ">
              <div class="col-md-4">
								<label class="col-md-4">學期</label>
								<div class="col-md-8">
									<select v-model="smtr" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(year, index) in selectYear()" :key="index" :value="year.value">{{year.text}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">學號</label>
								<div class="col-md-8">
									<input type="text" name="account" v-model="account" class="form-control" />
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">姓名</label>
								<div class="col-md-8">
									<input type="text" name="name" v-model="name" class="form-control" />
								</div>
							</div>
						</div>
					</div>
          <div class="row form-group">
            <div class="col-md-12 ">
              <div class="col-md-4">
                <label class="col-md-4">住宿類別</label>
                <div class="col-md-8">
                  <select v-model="dormitoryType" class="form-control">
                    <option value="N">一般宿舍</option>
                    <option value="V">寒暑假宿舍</option>
                    <option value="S">特殊原因宿舍</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">宿舍</label>
                <div class="col-md-8">
                  <input type="text" name="bedFloor" v-model="bedFloor" class="form-control"/>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">寢室</label>
                <div class="col-md-8">
                  <input type="text" name="bedRoom" v-model="bedRoom" class="form-control"/>
                </div>
              </div>
            </div>
          </div>
					<div class="row form-group">
						<div class="col-md-offset-4 col-md-4 ">
							<div class="col-md-offset-4 col-md-4">
								<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<div class="panel-collapse">
			<div class="panel-body">
				<div class="row form-group" >
					<div class="col-md-12 text-right form-inline">
            <button v-if="isAdmin('stay')" class="btn btn-danger m-xs" @click="showAddInterviewPopupControl(true)">新增晤談紀錄</button>
            <button v-if="isAdmin('stay')" class="btn btn-danger m-xs" @click="exportExcel">資料匯出</button>
            <button v-if="isAdmin('stay')" class="btn btn-danger m-xs" @click="exportNotification">列印違規通知單</button>
						<button v-if="isAdmin('stay')" class="btn btn-danger m-xs" @click="showViolatePopupControl(true)">新增違規/獎勵項目</button>
						<button v-if="isAdmin('stay') || sessionData.isRoomMage == 'Y'" class="btn btn-danger m-xs" @click="gotoView('stay.violateEdit',{editType:'N'})">新增違規/獎勵紀錄</button>
						<!-- <button v-if="sessionData.accountType == 'STU' || sessionData.isRoomMage != 'Y'" class="btn btn-danger m-xs" @click="gotoView('stay.violateEdit')">申請銷點</button> -->
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<table class="table table-no-more table-bordered table-striped mb-none" >
							<thead>
								<tr><th class="text-center" width="5%" >
                  <input type="checkbox" id="allCheck" name="allCheck" v-model="isAllCheck" @change="allSelection($event)" />
                </th>
									<th class="text-center" width="6%">學期</th>
									<th class="text-center" width="10%">學制</th>
									<th class="text-center" width="16%">系科年級</th>
									<th class="text-center" width="10%">學號</th>
									<th class="text-center" width="8%">姓名</th>
									<th class="text-center" width="14%">宿舍床位</th>
									<th class="text-center" width="8%">總(扣)點數</th>
									<th class="text-center" width="12%">銷扣點記錄</th>
									<th class="text-center" width="10%">晤談記錄</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in violateRecordGrid.rows" :key="index">
                  <td data-title=""  class="text-center">
                    <input  type="checkbox" :id="'checkId_'+index" name="checkId" :value="item" v-model="checkedList" />
                  </td>
									<td data-title="學期" class="text-center">{{item.smtr}}</td>
									<td data-title="學制" class="text-center">{{item.deptSsymStr}}</td>
									<td data-title="系科年級" class="text-center">
										<span v-if="item.deptCode">{{item.deptCodeStr}}-{{item.drade}}年{{item.dradeClass}}班</span>
									</td>
									<td data-title="學號" class="text-center">{{item.account}}</td>
									<td data-title="姓名" class="text-center">{{item.name}}</td>
									<td data-title="宿舍床位" class="text-center">
										{{`${item.bedFloor}${item.bedRoom}-${item.bed}`}}
									</td>
									<td data-title="總(扣)點數" class="text-center">
										<span>{{item.totalPoint}}</span>
									</td>
									<td data-title="銷扣點記錄" class="text-center">
										<a href="javascript:;" class="btn btn-danger btn-block" @click="gotoView('stay.deduct.detail', {applyId:item.applyId, account:item.account})">
											銷扣點記錄
										</a>
									</td>
									<td data-title="晤談記錄" class="text-center">
										<a href="javascript:;" class="btn btn-danger btn-block" @click="interviewAccount=item.account; showInterviewPopupControl(true)">晤談記錄</a>
									</td>

								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-12">
						<div class="text-center" >
							<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
						</div>
					</div>
				</div>
			</div>
		</div>
		<interviewPopup v-if="isShowInterviewPopup" :account="interviewAccount"/>
		<violateTypePopup v-if="isShowViolatePopup"/>
    <addInterviewPopup v-if="isShowAddInterviewPopup"/>
	</section>
</template>
<script>
import interviewPopup from './interviewPopup.vue';
import violateTypePopup from './violatePopup.vue';
import addInterviewPopup from "@/components/stay/deduct/addInterviewPopup";
export default {
	components:{
		interviewPopup,
		violateTypePopup,
    addInterviewPopup,
	},
	data(){
		return {
			smtr:"",
			account:"",
			name:"",
      bedFloor:"",
      bedRoom:"",
      dormitoryType:"",
			violateRecordGrid:{},
			page:1,
			pageSize:10,
			totalPage:0,
			isShowInterviewPopup:false,
			isShowViolatePopup:false,
      isShowAddInterviewPopup: false,
			interviewAccount:"",
      isAllCheck: false,
      checkedList: []
		}
	},
	mounted(){
		if(this.isAdmin('stay')){
      this.smtr = this.nowSmtr;
			this.gridInit();
		}else{
			this.gotoView("stay.deduct.detail", {account:this.sessionData.account, syear:this.nowSyear});
		}
	},
	methods:{
		updateGrid(page) {
			//更新Grid 必需
			this.page = page;
			this.gridInit();
		},
		gridInit(){
			let param = {
				page:this.page,
				pageSize:this.pageSize,
				model:{
					account:this.account,
					name:this.name,
          smtr:this.smtr,
          bedFloor:this.bedFloor,
          bedRoom:this.bedRoom,
          dormitoryType:this.dormitoryType
				}
			};
			// if(this.sessionData.accountType != "TCH"){
			// 	param.model.account = this.sessionData.account;
			// }
			const api = "/api/Violate/violateRecordTotalGrid";
			this.$axios.post(api, JSON.stringify(param)).then(resp =>{
				this.violateRecordGrid = resp.data.data;
				this.totalPage = this.violateRecordGrid.total
				this.page = this.violateRecordGrid.page;
				this.pageSize = this.violateRecordGrid.pageSize;
        if(this.isAllCheck) {
          this.checkedList = this.violateRecordGrid.rows;
        }
			});
		},
		selectYear(){
      let smtrArray = [];
      for(let y = parseInt(this.applySmtr.substring(0,3)); y > 107 ; y--){
        smtrArray.push({text:y+"年第二學期",value:y+"2"});
        smtrArray.push({text:y+"年第一學期",value:y+"1"});
        smtrArray.push({text:y+"年度",value:y});
      }
      return smtrArray;
		},
		showInterviewPopupControl(isOpen){
			if(isOpen == false){
				this.interviewAccount = "";
			}
			this.isShowInterviewPopup = isOpen;
		},
		showViolatePopupControl(isOpen){
			this.isShowViolatePopup = isOpen;
		},
    showAddInterviewPopupControl(isOpen){
      this.isShowAddInterviewPopup = isOpen;
    },
    exportExcel() {
      const api = "/api/Violate/exportViolateRecord";
      this.$axios.post( api, JSON.stringify({
        account:this.account,
        name:this.name,
        smtr:this.smtr,
        bedFloor:this.bedFloor,
        bedRoom:this.bedRoom
      }), {
        headers: { "Content-Type": "application/json" },
        responseType: "blob"
      }).then(resp => {
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "違規/獎勵_"+this.customFormatter(new Date())+".xlsx");
        document.body.appendChild(link);
        link.click();
      });
    },
    allSelection(event) {
      this.checkedList = [];
      if(event.target.checked){
        this.checkedList = this.violateRecordGrid.rows;
      }
    },
    exportNotification() {
      if(this.checkedList.length == 0) {
        bootbox.alert("請勾選欲產生通知單的資料");
        return false;
      }
      const api = "/api/Violate/exportViolateNotification";
      this.$axios.post( api, JSON.stringify({
        isAllCheck: this.isAllCheck,
        query: {
          account:this.account,
          name:this.name,
          smtr:this.smtr,
          bedFloor:this.bedFloor,
          bedRoom:this.bedRoom
        },
        checkedList: this.checkedList.map(apply => apply.applyId)
      }), {
        headers: { "Content-Type": "application/json" },
        responseType: "blob"
      }).then(resp => {
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "宿舍違規通知單_"+this.customFormatter(new Date())+".docx");
        document.body.appendChild(link);
        link.click();
      });
    }
	}
}
</script>
